import { StyleSheet } from 'react-native';

export const colors = { primary: '#003c84', navy: '#00004C', steel: '#5f7da1', background: '#f4f7fb' };

// Preserve each screen's structure and status colors while unifying its surfaces.
export function createScreenStyles(definitions) {
  const result = {};
  Object.entries(definitions).forEach(([name, original]) => {
    const style = { ...original };
    if (['#d5d5d5', '#e5e5e5', '#f3f3f3', '#d0d0d0'].includes(style.backgroundColor)) style.backgroundColor = colors.background;
    if (style.shadowOpacity) {
      style.shadowColor = colors.navy;
      style.shadowOpacity = 0.06;
      style.shadowRadius = 10;
      style.shadowOffset = { width: 0, height: 3 };
      style.elevation = 2;
    }
    if (style.borderRadius && style.borderRadius < 16) style.borderRadius = 12;
    if (/^textDesc/.test(name)) { style.fontSize = Math.max(style.fontSize || 14, 14); style.lineHeight = 22; }
    if (['containerGeral', 'headerContainer', 'ItemImg'].includes(name) && style.backgroundColor === '#fff') {
      style.borderRadius = 16; style.borderWidth = 1; style.borderColor = '#e1e8f2';
      style.paddingHorizontal = 14; style.paddingVertical = 12;
    }
    if (/^(menuItem|buttonDone|buttonPend|btnEntrar)/.test(name)) {
      style.minHeight = 48;
      if (typeof style.height === 'number') style.height = Math.max(48, style.height);
    }
    if (name === 'textSearch' && definitions.searchBar) {
      style.flex = 1; style.width = undefined; style.minWidth = 0; style.marginLeft = 8; style.fontSize = 16;
    } else if (/^(textSearch|input)/.test(name)) {
      style.fontSize = 16; style.minHeight = 50; style.borderColor = '#d9e3f0'; style.borderRadius = 12;
    }
    if (['container', 'content'].includes(name)) {
      style.width = '100%'; style.maxWidth = 920; style.alignSelf = 'center';
    }
    if (name === 'searchBar') {
      style.alignItems = 'center'; style.height = 60; style.paddingHorizontal = 12; style.paddingTop = 0;
    }
    if (/^highlight/.test(name)) { style.borderRadius = 16; style.marginHorizontal = 10; style.marginBottom = 10; }
    result[name] = style;
  });
  return StyleSheet.create(result);
}
